import React, { useEffect, useState } from 'react'
import ListaAprobarVacaciones from './ListaAprobarVacaciones'
import { useParams } from 'react-router-dom'
import { ApiSolicitudVacacionesService } from 'services/ApiSolicitudVacacionesService'

const AprobarVacaciones = () => {
    const [datos, setDatos] = useState([])
    const [update, setUpdate] = useState(false)

    const {empleadoId} = useParams();

    useEffect(() => {
      const fetchData = async () =>{
        const response = await ApiSolicitudVacacionesService.getSolicitadasByEmpleadoId(empleadoId, null, null, "PENDIENTE");
        response.json().then(data => setDatos(data));
      }
      fetchData();
    }, [update, empleadoId])
    

  return (
    <>
        <br></br>
       <ListaAprobarVacaciones datos={datos} setDatos={setDatos} setUpdate={setUpdate} update={update}/>
        
    </>
  )
}

export default AprobarVacaciones